import { Action } from 'redux-actions';
import { all, put, takeEvery } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { executeSagaRequest } from '@savgroup-front-common/core/services';

import { getStockItemRequest } from '../../../api/SparePart/getStockItemQuery';
import { getStockItemsByRequestLineRequest } from '../../../api/SparePart/getStockItemsByRequestLineQuery';

import {
  GetStockItemDetailsPayload,
  GetStockItemsDetailsBySparePartRequestPayload,
} from './actionCreators';
import * as types from './actionTypes';

function* getStockItemDetailsWorker(action: {
  payload: GetStockItemDetailsPayload;
}): Generator {
  const { stockItemId } = action.payload;

  yield executeSagaRequest(
    types.GET_STOCK_ITEM_DETAILS,
    getStockItemRequest({ stockItemId }),
    { indexer: stockItemId },
  );

  yield put(types.GET_STOCK_ITEM_DETAILS.end({ stockItemId }));
}
function* getStockItemDetailsWatcher() {
  yield takeEvery<Action<GetStockItemDetailsPayload>>(
    types.GET_STOCK_ITEM_DETAILS.BASE,
    getStockItemDetailsWorker,
  );
}

function* getStockItemsDetailsBySparePartRequestLineWorker(action: {
  payload: GetStockItemsDetailsBySparePartRequestPayload;
}): Generator {
  const { sparePartRequestLineId } = action.payload;

  yield executeSagaRequest(
    types.GET_STOCK_ITEMS_DETAILS_BY_SPARE_PART_REQUEST_LINE,
    getStockItemsByRequestLineRequest({ sparePartRequestLineId }),
    { indexer: sparePartRequestLineId, sparePartRequestLineId },
  );

  yield put(
    types.GET_STOCK_ITEMS_DETAILS_BY_SPARE_PART_REQUEST_LINE.end({
      sparePartRequestLineId,
    }),
  );
}
function* getStockItemsDetailsBySparePartRequestLineWatcher() {
  yield takeEvery<Action<GetStockItemsDetailsBySparePartRequestPayload>>(
    types.GET_STOCK_ITEMS_DETAILS_BY_SPARE_PART_REQUEST_LINE.BASE,
    getStockItemsDetailsBySparePartRequestLineWorker,
  );
}

export default function* stockItemDetailsSaga(): Generator {
  try {
    yield all([
      getStockItemDetailsWatcher(),
      getStockItemsDetailsBySparePartRequestLineWatcher(),
    ]);
  } catch (error) {
    logCritical(error);
  }
}
